// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"ProfileMenu_dropdown__XuEJb","avatar":"ProfileMenu_avatar__2Av2u","menuIcon":"ProfileMenu_menuIcon__3fhBX"};